import React from 'react';

export const SuccessIcon = props => {
  return (
    <span
      className="solstice-icon- solstice-icon-success"
      style={props.style}
    />
  );
};
